// Centralized API and asset hosts.
export const apiPathUrl =
  process.env.REACT_APP_API_BASE_URL || 'https://api.bookcleany.com';
    
export const baseImageUrl = apiPathUrl;
export const googleMapsLibraries = ['places'];
export const wsPathUrl = apiPathUrl.startsWith('https')
  ? apiPathUrl.replace('https', 'wss')
  : apiPathUrl.replace('http', 'ws');
